import { IconButton, List, ListItem, ListItemButton, ListItemText, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { LoanApplicationTablePropsType } from "../../../types/container.type";
import MoreVertIcon from '@mui/icons-material/MoreVert';

export const LoanApplicationTable: React.FC<LoanApplicationTablePropsType> = ({ rows, handleEllipsisButtonClick, handleActionItemClick, selectedLoan, dropdownRef }) => {
    const actions = ["Edit Draft", "Proceed to Book", "Delete Draft"];
    const loanProductTableHeaders = ["Loan ID", "Loan Product", "Obligor", "Status", "Action"];

    return (
        <BaseTable headers={loanProductTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{row?.serialNo.toString().padStart(3, '0')}</TableCell>
                            <TableCell>{row?.loanProductName?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                            <TableCell>{row?.obligor?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                            <TableCell>{row?.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : ""}</TableCell>
                            <TableCell>
                                <IconButton
                                    sx={{
                                        borderRadius: "0.5rem",
                                        backgroundColor: "var(--sky-blue-color)",
                                        "&:hover": {
                                            backgroundColor: "var(--sky-blue-color)"
                                        }
                                    }}
                                    onClick={(e) => handleEllipsisButtonClick(e, row)}
                                >
                                    <MoreVertIcon
                                        sx={{
                                            color: "#FFFFFF",
                                            display: "inline-flex",
                                        }}
                                    />
                                </IconButton>
                                {(selectedLoan?.id && selectedLoan?.id === row?.id) && (
                                    <List
                                        component={"ul"}
                                        ref={dropdownRef}
                                        className="dropdown-modal"
                                    >
                                        {actions.map((action, index) => (
                                            <ListItem
                                                key={index}
                                                onClick={(e) => handleActionItemClick(e, selectedLoan?.id, action)}
                                            >
                                                <ListItemButton>
                                                    <ListItemText
                                                        primary={action}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                )}
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
